import { render, staticRenderFns } from "./TimetableViewDeparturesCompact.vue?vue&type=template&id=7884f1f8"
import script from "./TimetableViewDeparturesCompact.vue?vue&type=script&lang=js"
export * from "./TimetableViewDeparturesCompact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports